import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Country, State } from "../countries/types";
import { CenterProps } from "./types";
import {
  CENTER_MAP,
  ZOOM_MAP,
} from "../../pages/mainPage/Statistics/Map/types";
import { defaultYear } from "../../config";

const initialState: {
  zoom: number;
  selectedCountry: Country | undefined;
  selectedCountryBelongsToOtherRegion: State | undefined;
  caricomCountry: Country | undefined;
  defaultCountry: Country | undefined;
  center: CenterProps;
  year: string;
} = {
  zoom: ZOOM_MAP,
  selectedCountry: undefined,
  selectedCountryBelongsToOtherRegion: undefined,
  caricomCountry: undefined,
  defaultCountry: undefined,
  center: CENTER_MAP,
  year: defaultYear,
};

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setZoom: (state, action: PayloadAction<number>) => {
      state.zoom = action.payload;
    },
    resetZoom: (state) => {
      state.zoom = initialState.zoom;
    },
    setCenter: (state, action: PayloadAction<CenterProps>) => {
      state.center = action.payload;
    },
    resetCenter: (state) => {
      state.center = initialState.center;
    },
    setYear: (state, action: PayloadAction<string>) => {
      state.year = action.payload;
    },
    resetYear: (state) => {
      state.year = initialState.year;
    },

    selectedCountry: (state, action: PayloadAction<Country>) => {
      state.selectedCountry = action.payload;
    },
    setSelectedCountry: (state, action: PayloadAction<Country | undefined>) => {
      state.selectedCountry = action.payload;
    },
    defaultCountry: (state, action: PayloadAction<Country>) => {
      state.defaultCountry = action.payload;
    },
    setDefaultCountry: (state, action: PayloadAction<Country | undefined>) => {
      state.defaultCountry = action.payload;
    },

    selectedCountryBelongsToOtherRegion: (
      state,
      action: PayloadAction<State>
    ) => {
      state.selectedCountryBelongsToOtherRegion = action.payload;
    },
    setSelectedCountryBelongsToOtherRegion: (
      state,
      action: PayloadAction<State | undefined>
    ) => {
      state.selectedCountryBelongsToOtherRegion = action.payload;
    },

    caricomCountry: (state, action: PayloadAction<Country>) => {
      state.caricomCountry = action.payload;
    },
    setCaricomCountry: (state, action: PayloadAction<Country | undefined>) => {
      state.caricomCountry = action.payload;
    },
  },
});

export const {
  setZoom,
  resetZoom,
  setCenter,
  resetCenter,
  setYear,
  resetYear,
  selectedCountry,
  setSelectedCountryBelongsToOtherRegion,
  setSelectedCountry,
  defaultCountry,
  caricomCountry,
  setCaricomCountry,
  setDefaultCountry,
} = mapSlice.actions;

export default mapSlice.reducer;
